import { createWebhook, getWebhooks } from '@/features/zendesk-app'
import { useRouteEntryPoint } from '@/hooks/useRouteEntryPoint'
import { useGetRoute } from '@/lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { useWebhookSubscriptions } from './useWebhookSubscriptions'

export const useWebhook = (projectId: number, routeId: number) => {
  const subscriptions = useWebhookSubscriptions()
  const endpoint = useRouteEntryPoint(projectId, routeId)

  const {
    data: { route },
  } = useGetRoute(projectId, routeId)

  const createRouteWebhook = async () => {
    const { webhook } = await createWebhook({
      name: `Knots studio route #${routeId}`,
      http_method: 'POST',
      request_format: 'json',
      status: 'active',
      endpoint,
      authentication: {
        add_position: 'header',
        data: {
          name: 'x-api-key',
          value: route.apiKey,
        },
        type: 'api_key',
      },
      ...(subscriptions.length ? { subscriptions } : {}),
    })

    return webhook
  }

  const { data: webhook, isLoading } = useQuery({
    queryKey: ['app', 'zendesk', 'webhook', endpoint],
    queryFn: async () => {
      const { webhooks } = await getWebhooks()
      const webhook = webhooks.find((webhook) => webhook.endpoint === endpoint)
      return webhook ?? (await createRouteWebhook())
    },
  })
  return { webhook, isLoading }
}
